import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiDownload, FiFile, FiMusic, FiX } from 'react-icons/fi';
import '../../css/adhoc-drive.css';

const extension = (file) => String(file?.name || file?.url || '').split('?')[0].split('.').pop().toLowerCase();

const previewType = (file) => {
  const mime = file?.mime || '';
  const ext = extension(file);
  if (mime.startsWith('image/') || ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif'].includes(ext)) return 'image';
  if (mime.startsWith('video/') || ['mp4', 'webm', 'mov', 'm4v'].includes(ext)) return 'video';
  if (mime.startsWith('audio/') || ['mp3', 'wav', 'ogg', 'm4a', 'aac'].includes(ext)) return 'audio';
  if (mime === 'application/pdf' || ext === 'pdf') return 'document';
  if (mime === 'text/plain' || ['txt', 'log', 'md', 'csv'].includes(ext)) return 'document';
  return 'unsupported';
};

const FilePreviewModal = ({ file, onClose, onDownload }) => {
  const { t } = useTranslation();
  if (!file) return null;
  const type = previewType(file);
  const name = file.name || t('drive.archivoSinNombre');

  return (
    <div className="drive-preview-backdrop" onMouseDown={onClose}>
      <div className="drive-preview" role="dialog" aria-modal="true" aria-label={name} onMouseDown={(event) => event.stopPropagation()}>
        <div className="drive-preview-cabecera">
          <div><small>{t('drive.vistaPrevia')}</small><strong>{name}</strong></div>
          <div>
            <button onClick={() => onDownload(file)} title={t('drive.descargar')}><FiDownload /></button>
            <button onClick={onClose} title={t('comun.cerrar')}><FiX /></button>
          </div>
        </div>
        <div className="drive-preview-body">
          {file.loading ? (
            <div className="drive-preview-loading"><i /></div>
          ) : type === 'image' ? (
            <img src={file.url} alt={name} />
          ) : type === 'video' ? (
            <video src={file.url} controls />
          ) : type === 'audio' ? (
            <div className="drive-audio-preview"><FiMusic /><strong>{name}</strong><audio src={file.url} controls /></div>
          ) : type === 'document' ? (
            <iframe src={file.url} title={name} />
          ) : (
            <div className="drive-preview-unsupported"><FiFile /><h2>{t('drive.sinVistaPreviaTitulo')}</h2><p>{t('drive.sinVistaPrevia')}</p><button className="drive-btn primary" onClick={() => onDownload(file)}><FiDownload /> {t('drive.descargar')}</button></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
